import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoleEditFormBlock } from './components/RoleEditFormBlock';
import { useRolesEdit } from './hooks/useRolesEdit';
import type { RoleEditData } from './types/rolesEdit.types';

export function RolesEditPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const { role, availableModules, isLoading, isSubmitting, updateRole } = useRolesEdit(id);
  const [formData, setFormData] = useState<Partial<RoleEditData>>({});

  useEffect(() => {
    if (role) setFormData(role);
  }, [role]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const success = await updateRole(formData);
    if (success) navigate('?tab=roles');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex flex-col gap-3 rounded-md border border-slate-100 bg-white p-3 shadow-sm md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('?tab=roles')}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-slate-100 bg-white text-slate-600"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <div className="space-y-2 text-sm">
            <h1 className="text-lg font-medium text-slate-900">Chỉnh sửa vai trò</h1>
            <p className="text-slate-500">Cập nhật quyền, phạm vi và mô tả vai trò.</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => navigate('?tab=roles')}
            className="h-10 flex-1 rounded-md border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 md:flex-none"
          >
            Hủy
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isLoading}
            className="h-10 flex-1 rounded-md bg-emerald-600 px-4 text-sm font-semibold text-white disabled:opacity-50 md:flex-none"
          >
            {isSubmitting ? 'Đang lưu' : 'Lưu thay đổi'}
          </button>
        </div>
      </div>

      <RoleEditFormBlock
        formData={formData}
        availableModules={availableModules}
        isLoading={isLoading}
        onChange={setFormData}
      />
    </form>
  );
}
